<!-- 产业服务-仓库租赁需求 -->
<template>
<div class="info-block">
  <router-link :to="{path: '/sggqDetail'}" class="info-block-a">
    <div class="div-1">
      <div class="div-1-1"><span>【仓库租赁需求】</span>{{info.name}}</div>
      <div class="div-1-2">{{info.intro.substring(0,55)}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table" cellpadding="2" cellspacing="0" >
          <tr>
            <td class="td-title">需求面积(m²)</td>
            <td class="td-title">租期</td>
            <td class="td-title">启动年月</td>
            <td class="td-title">需求编号</td>
            <td class="td-title">状态</td>
            <td class="td-title">发布时间</td>
          </tr>
          <tr>
            <td class="td-value">{{info.able_area}}</td>
            <td class="td-value">{{info.able_area}}</td>
            <td class="td-value">{{info.able_area}}</td>
            <td class="td-value">{{info.start_area}}</td>
            <td class="td-value">报价中</td>
            <td class="td-value">{{info.start_area}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <a class="td-action-1">收藏需求</a>
        <a class="td-action-2">了解详情</a>
      </div>
    </div>


  </router-link>
</div>
</template>

<script>
export default {
  name: 'CyfwInfo2',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:140px;
  padding:0px;
  margin:0px 1px 20px 0px;
  //background-color: #F6F8F9;
  border:1px solid #fff;
  background-size: 220px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px #eee;
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 5px 0px 0px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:30px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  line-height:26px;
  color:#000;
  padding:2px 10px 2px 0px;
}

.div-1-1 span{
  font-size:14px;
  text-align:left;
  color:red;
}

.div-1-2{
  position:relative;
  height:40px;
  line-height:20px;
  text-align:left;
  color:#515151;
  padding:0px 150px 0px 5px;
}

.div-1-4{
  position:relative;
  height:60px;
  //background:green;
  text-align:left;
  color:#888;
  padding:10px 150px 10px 5px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:120px;
  color:#888;
  padding-left:0px;
}

.div-1-4-table .td-value{
  text-align:left;
  width:100px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
  color:var(--color6);
}


.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:100px;
  margin:15px 20px 15px 0px;
  padding-left:10px;
  //background:yellow;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:20px;
  color:#888;
  line-height:20px;
  text-align:center;
  background-image:url(./../../assets/collection.png);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 5px 4px;
}

.div-3 .td-action-1:hover{
  color:var(--color6)
}

.div-3 .td-action-2{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:10px;
  border:1px solid var(--color7);
  color:#515151;
  line-height:20px;
  text-align:center;
}

.div-3 .td-action-2:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}

</style>



// WEBPACK FOOTER //
// src/components/module/CyfwInfo2.vue